(function (root, factory) {
  const api = factory();
  root.HadiyahDeliveryRules = api;
  if (typeof module === 'object' && module.exports) module.exports = api;
})(typeof globalThis !== 'undefined' ? globalThis : window, function () {
  'use strict';

  const TIMEZONE = 'Asia/Kolkata';
  const DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const MONTH_NAMES = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December',
  ];

  const DEFAULT_CONFIG = {
    version: 1,
    timezone: TIMEZONE,
    propertyNames: {
      date: 'Delivery Date',
      day: 'Delivery Day',
      time: 'Delivery Time',
      pincode: 'Pincode',
    },
    productGroups: [
      {
        id: 'ramadan-eid-islamic',
        name: 'Ramadan, Eid and Islamic-product collections',
        enabled: true,
        priority: 10,
        match: {
          productIds: [],
          productHandles: [],
          tags: [],
          collectionIds: [],
          collectionHandles: ['ramadan', 'ramadan-gifts', 'eid', 'eid-gifts', 'islamic-products', 'islamic-gifts'],
          collectionTitles: ['Ramadan', 'Ramadan Gifts', 'Eid', 'Eid Gifts', 'Islamic Products', 'Islamic Gifts'],
        },
        dateRuleId: 'ramadan-5-6-7',
        timeSlotRuleId: 'none',
      },
      {
        id: 'wedding-sawab-e-jariya',
        name: 'Wedding and Sawab-e-Jariya collections',
        enabled: true,
        priority: 20,
        match: {
          productIds: [],
          productHandles: [],
          tags: [],
          collectionIds: [],
          collectionHandles: ['wedding', 'wedding-gifts', 'sawab-e-jariya', 'sawab-e-jariya-gifts'],
          collectionTitles: ['Wedding', 'Wedding Gifts', 'Sawab-e-Jariya', 'Sawab E Jariya', 'Sawab-e-Jariya Gifts'],
        },
        dateRuleId: 'standard-6-7-8',
        timeSlotRuleId: 'none',
      },
      {
        id: 'cakes-flowers-same-day',
        name: 'Cakes, Flowers and Same Day Delivery tags',
        enabled: true,
        priority: 30,
        match: {
          productIds: [],
          productHandles: [],
          tags: ['Cakes', 'Flowers', 'Same Day Delivery'],
          collectionIds: [],
          collectionHandles: [],
          collectionTitles: [],
        },
        dateRuleId: 'same-day',
        timeSlotRuleId: 'same-day-slots',
      },
      {
        id: 'winni-p',
        name: 'Winni_P collection',
        enabled: true,
        priority: 40,
        match: {
          productIds: [],
          productHandles: [],
          tags: [],
          collectionIds: [],
          collectionHandles: ['winni-p', 'winni_p'],
          collectionTitles: ['Winni_P', 'Winni P'],
        },
        dateRuleId: 'standard-6-7-8',
        timeSlotRuleId: 'none',
      },
      {
        id: 'default',
        name: 'Default fallback',
        enabled: true,
        priority: 9999,
        match: {
          productIds: [], productHandles: [], tags: [], collectionIds: [], collectionHandles: [], collectionTitles: [],
        },
        dateRuleId: 'standard-6-7-8',
        timeSlotRuleId: 'none',
      },
    ],
    dateRules: [
      {
        id: 'standard-6-7-8',
        name: 'Standard 6/7/8 day shipping',
        deliveryMethod: 'shipping',
        availableWeekdays: [0, 1, 2, 3, 4, 5, 6],
        leadDays: { default: 6, 0: 7, 6: 8 },
        cutoffTime: '23:59',
        maxDaysAhead: { default: 730, 0: 90, 6: 90 },
        countUnavailableAsNonWorkingDays: false,
        carryCutoffOverUnavailableDates: true,
        availabilityStartDate: '',
        availabilityEndDate: '',
        disabledDates: [],
        oneOffDates: [],
      },
      {
        id: 'ramadan-5-6-7',
        name: 'Ramadan 5/6/7 day shipping',
        deliveryMethod: 'shipping',
        availableWeekdays: [0, 1, 2, 3, 4, 5, 6],
        leadDays: { default: 5, 0: 6, 6: 7 },
        cutoffTime: '23:59',
        maxDaysAhead: { default: 730, 0: 90, 6: 90 },
        countUnavailableAsNonWorkingDays: false,
        carryCutoffOverUnavailableDates: true,
        availabilityStartDate: '',
        availabilityEndDate: '',
        disabledDates: [],
        oneOffDates: [],
      },
      {
        id: 'same-day',
        name: 'Same-day shipping',
        deliveryMethod: 'shipping',
        availableWeekdays: [0, 1, 2, 3, 4, 5, 6],
        leadDays: { default: 0 },
        cutoffTime: '14:00',
        maxDaysAhead: { default: 180 },
        countUnavailableAsNonWorkingDays: false,
        carryCutoffOverUnavailableDates: true,
        availabilityStartDate: '',
        availabilityEndDate: '',
        disabledDates: [],
        oneOffDates: [],
      },
    ],
    timeSlotRules: [
      {
        id: 'none', name: 'No time slots', enabled: false, required: false,
        autoSelectFirst: false, showUnavailableSlots: true, preparationMinutes: 0, slots: [], exceptions: [],
      },
      {
        id: 'same-day-slots',
        name: 'Same-day delivery slots',
        enabled: true,
        required: true,
        autoSelectFirst: true,
        showUnavailableSlots: true,
        preparationMinutes: 120,
        preparationBasis: 'slot_start',
        slots: [
          { label: '10:00 AM – 2:00 PM', start: '10:00', end: '14:00' },
          { label: '2:00 PM – 6:00 PM', start: '14:00', end: '18:00' },
          { label: '6:00 PM – 9:00 PM', start: '18:00', end: '21:00' },
        ],
        exceptions: [],
      },
    ],
    postcode: {
      enabled: false,
      blockAddToCart: false,
      persistLastPincode: false,
      placeholder: 'Enter your 6-digit pincode',
      availableMessage: 'Delivery is available for this pincode.',
      unavailableMessage: 'Delivery is not available for this pincode.',
      rules: [],
      assignments: [],
    },
  };

  const clone = (value) => JSON.parse(JSON.stringify(value));
  const isObject = (value) => Boolean(value) && typeof value === 'object' && !Array.isArray(value);
  const normalizeText = (value) => String(value == null ? '' : value).trim().toLowerCase().replace(/[_\s]+/g, '-');
  const normalizeId = (value) => String(value == null ? '' : value).replace(/^gid:\/\/shopify\/(Product|Collection)\//i, '').trim();
  const int = (value, fallback, min = 0, max = 10000) => {
    const parsed = Number.parseInt(value, 10);
    return Number.isFinite(parsed) ? Math.min(max, Math.max(min, parsed)) : fallback;
  };
  const stringList = (value) => Array.isArray(value) ? value.map(String).map((item) => item.trim()).filter(Boolean) : [];
  const idList = (value) => stringList(value).map(normalizeId).filter(Boolean);
  const validDateKey = (value) => /^\d{4}-\d{2}-\d{2}$/.test(String(value || ''));
  const validTime = (value) => /^(?:[01]\d|2[0-3]):[0-5]\d$/.test(String(value || ''));

  function normalizeWeekdayMap(value, fallback) {
    const source = isObject(value) ? value : {};
    const result = { default: int(source.default, int(fallback.default, 0)) };
    for (let day = 0; day < 7; day += 1) {
      if (source[day] != null && source[day] !== '') result[day] = int(source[day], result.default);
      else if (fallback[day] != null) result[day] = int(fallback[day], result.default);
    }
    return result;
  }

  function normalizeMatch(value) {
    const source = isObject(value) ? value : {};
    return {
      productIds: idList(source.productIds),
      productHandles: stringList(source.productHandles),
      tags: stringList(source.tags),
      collectionIds: idList(source.collectionIds),
      collectionHandles: stringList(source.collectionHandles),
      collectionTitles: stringList(source.collectionTitles || source.collections),
    };
  }

  function normalizeProductGroups(value, fallback) {
    if (!Array.isArray(value)) return clone(fallback);
    const rows = value.filter(isObject).map((row, index) => ({
      id: String(row.id || `group-${index + 1}`).trim(),
      name: String(row.name || row.id || `Group ${index + 1}`).trim(),
      enabled: row.enabled !== false,
      priority: int(row.priority, 100 + index, -10000, 10000),
      match: normalizeMatch(row.match),
      dateRuleId: String(row.dateRuleId || '').trim(),
      timeSlotRuleId: String(row.timeSlotRuleId || 'none').trim(),
    })).filter((row) => row.id && row.dateRuleId);
    return rows.length ? rows : clone(fallback);
  }

  function normalizeDateRules(value, fallback) {
    if (!Array.isArray(value)) return clone(fallback);
    const fallbackById = new Map(fallback.map((row) => [row.id, row]));
    const rows = value.filter(isObject).map((row, index) => {
      const id = String(row.id || '').trim();
      const base = fallbackById.get(id) || fallback[0];
      const oneOffDates = Array.isArray(row.oneOffDates) ? row.oneOffDates.map((entry) => {
        if (typeof entry === 'string') return { date: entry, available: true };
        return isObject(entry) ? { date: String(entry.date || ''), available: entry.available !== false } : null;
      }).filter((entry) => entry && validDateKey(entry.date)) : clone(base.oneOffDates || []);
      return {
        id: id || `date-rule-${index + 1}`,
        name: String(row.name || base.name || id).trim(),
        deliveryMethod: String(row.deliveryMethod || base.deliveryMethod || 'shipping'),
        availableWeekdays: Array.isArray(row.availableWeekdays)
          ? row.availableWeekdays.map((day) => int(day, -1, -1, 6)).filter((day, i, all) => day >= 0 && all.indexOf(day) === i)
          : clone(base.availableWeekdays),
        leadDays: normalizeWeekdayMap(row.leadDays, base.leadDays),
        cutoffTime: validTime(row.cutoffTime) ? row.cutoffTime : base.cutoffTime,
        maxDaysAhead: normalizeWeekdayMap(row.maxDaysAhead, base.maxDaysAhead),
        countUnavailableAsNonWorkingDays: row.countUnavailableAsNonWorkingDays === true,
        carryCutoffOverUnavailableDates: row.carryCutoffOverUnavailableDates !== false,
        availabilityStartDate: validDateKey(row.availabilityStartDate) ? row.availabilityStartDate : '',
        availabilityEndDate: validDateKey(row.availabilityEndDate) ? row.availabilityEndDate : '',
        disabledDates: Array.isArray(row.disabledDates) ? stringList(row.disabledDates).filter(validDateKey) : clone(base.disabledDates),
        oneOffDates,
      };
    }).filter((row) => row.id);
    return rows.length ? rows : clone(fallback);
  }

  function normalizeTimeSlotRules(value, fallback) {
    if (!Array.isArray(value)) return clone(fallback);
    const fallbackById = new Map(fallback.map((row) => [row.id, row]));
    const rows = value.filter(isObject).map((row, index) => {
      const id = String(row.id || '').trim();
      const base = fallbackById.get(id) || fallback[0];
      const slots = Array.isArray(row.slots) ? row.slots.filter(isObject).map((slot) => ({
        label: String(slot.label || '').trim(), start: String(slot.start || ''), end: String(slot.end || ''),
      })).filter((slot) => slot.label && validTime(slot.start) && validTime(slot.end)) : clone(base.slots);
      return {
        id: id || `time-rule-${index + 1}`,
        name: String(row.name || base.name || id).trim(),
        enabled: row.enabled === true,
        required: row.required === true,
        autoSelectFirst: row.autoSelectFirst !== false,
        showUnavailableSlots: row.showUnavailableSlots !== false,
        preparationMinutes: int(row.preparationMinutes, base.preparationMinutes || 0, 0, 1440),
        preparationBasis: row.preparationBasis === 'slot_start' ? 'slot_start' : (base.preparationBasis || 'slot_start'),
        slots,
        exceptions: Array.isArray(row.exceptions) ? clone(row.exceptions) : [],
      };
    }).filter((row) => row.id);
    return rows.length ? rows : clone(fallback);
  }

  function normalizePostcode(value, fallback) {
    const source = isObject(value) ? value : {};
    const rules = Array.isArray(source.rules) ? source.rules.filter(isObject).map((rule, index) => ({
      id: String(rule.id || `postcode-rule-${index + 1}`).trim(),
      name: String(rule.name || rule.id || `Postcode rule ${index + 1}`).trim(),
      enabled: rule.enabled === true,
      priority: int(rule.priority, 100 + index, -10000, 10000),
      type: ['whitelist', 'blacklist', 'pan_india'].includes(rule.type) ? rule.type : 'whitelist',
      pincodes: stringList(rule.pincodes).map(normalizePincode).filter((pin) => pin.length === 6),
      ranges: Array.isArray(rule.ranges) ? rule.ranges.filter(isObject).map((range) => ({
        from: normalizePincode(range.from), to: normalizePincode(range.to),
      })).filter((range) => range.from.length === 6 && range.to.length === 6 && range.from <= range.to) : [],
      availableMessage: String(rule.availableMessage || '').trim(),
      unavailableMessage: String(rule.unavailableMessage || '').trim(),
    })).filter((rule) => rule.id) : [];
    const assignments = Array.isArray(source.assignments) ? source.assignments.filter(isObject).map((assignment, index) => ({
      id: String(assignment.id || `postcode-assignment-${index + 1}`).trim(),
      enabled: assignment.enabled === true,
      priority: int(assignment.priority, 100 + index, -10000, 10000),
      ruleId: String(assignment.ruleId || '').trim(),
      scope: ['product', 'collection', 'all'].includes(assignment.scope) ? assignment.scope : 'all',
      productIds: idList(assignment.productIds),
      productHandles: stringList(assignment.productHandles),
      collectionIds: idList(assignment.collectionIds),
      collectionHandles: stringList(assignment.collectionHandles),
      collectionTitles: stringList(assignment.collectionTitles),
    })).filter((assignment) => assignment.id && assignment.ruleId) : [];
    return {
      enabled: source.enabled === true,
      blockAddToCart: source.blockAddToCart === true,
      persistLastPincode: source.persistLastPincode === true,
      placeholder: String(source.placeholder || fallback.placeholder),
      availableMessage: String(source.availableMessage || fallback.availableMessage),
      unavailableMessage: String(source.unavailableMessage || fallback.unavailableMessage),
      rules,
      assignments,
    };
  }

  // Each top-level section falls back independently so malformed postcode data cannot invalidate date rules.
  function normalizeConfig(value) {
    const source = isObject(value) ? value : {};
    const fallback = DEFAULT_CONFIG;
    return {
      version: int(source.version, fallback.version, 1, 999),
      timezone: source.timezone === TIMEZONE ? TIMEZONE : fallback.timezone,
      timezoneWasCorrected: Boolean(source.timezone && source.timezone !== TIMEZONE),
      propertyNames: {
        date: String(source.propertyNames?.date || fallback.propertyNames.date),
        day: String(source.propertyNames?.day || fallback.propertyNames.day),
        time: String(source.propertyNames?.time || fallback.propertyNames.time),
        pincode: String(source.propertyNames?.pincode || fallback.propertyNames.pincode),
      },
      productGroups: normalizeProductGroups(source.productGroups, fallback.productGroups),
      dateRules: normalizeDateRules(source.dateRules, fallback.dateRules),
      timeSlotRules: normalizeTimeSlotRules(source.timeSlotRules, fallback.timeSlotRules),
      postcode: normalizePostcode(source.postcode, fallback.postcode),
    };
  }

  function normalizePincode(value) {
    return String(value == null ? '' : value).replace(/\D/g, '').slice(0, 6);
  }

  function contextSets(context) {
    const collections = Array.isArray(context?.collections) ? context.collections : [];
    return {
      productId: normalizeId(context?.id),
      productHandle: normalizeText(context?.handle),
      tags: new Set(stringList(context?.tags).map(normalizeText)),
      collectionIds: new Set(collections.map((item) => normalizeId(item?.id)).filter(Boolean)),
      collectionHandles: new Set(collections.map((item) => normalizeText(item?.handle)).filter(Boolean)),
      collectionTitles: new Set(collections.map((item) => normalizeText(item?.title)).filter(Boolean)),
    };
  }

  function matchAny(source, targets, normalizer = normalizeText) {
    return targets.some((target) => source.has(normalizer(target)));
  }

  function groupMatches(group, context) {
    const match = group.match;
    const sets = contextSets(context);
    const criteriaCount = Object.values(match).reduce((total, values) => total + values.length, 0);
    if (criteriaCount === 0) return group.id === 'default';
    return match.productIds.includes(sets.productId)
      || match.productHandles.some((value) => normalizeText(value) === sets.productHandle)
      || matchAny(sets.tags, match.tags)
      || matchAny(sets.collectionIds, match.collectionIds, normalizeId)
      || matchAny(sets.collectionHandles, match.collectionHandles)
      || matchAny(sets.collectionTitles, match.collectionTitles);
  }

  // Enabled groups are resolved by ascending priority; the first normalized match wins.
  function matchProductGroup(config, context) {
    const groups = config.productGroups.filter((group) => group.enabled).slice().sort((a, b) => a.priority - b.priority);
    return groups.find((group) => groupMatches(group, context))
      || groups.find((group) => group.id === 'default')
      || groups[groups.length - 1]
      || null;
  }

  function resolveProfile(config, context) {
    const group = matchProductGroup(config, context);
    if (!group) return { group: null, dateRule: null, timeSlotRule: null };
    return {
      group,
      dateRule: config.dateRules.find((rule) => rule.id === group.dateRuleId) || config.dateRules[0] || null,
      timeSlotRule: config.timeSlotRules.find((rule) => rule.id === group.timeSlotRuleId)
        || config.timeSlotRules.find((rule) => rule.id === 'none') || null,
    };
  }

  function zonedParts(timestamp = Date.now()) {
    const formatter = new Intl.DateTimeFormat('en-CA', {
      timeZone: TIMEZONE, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23',
    });
    const values = {};
    formatter.formatToParts(new Date(timestamp)).forEach((part) => {
      if (part.type !== 'literal') values[part.type] = Number(part.value);
    });
    const dateKey = `${values.year}-${String(values.month).padStart(2, '0')}-${String(values.day).padStart(2, '0')}`;
    return { ...values, dateKey, weekday: weekday(dateKey), minuteOfDay: values.hour * 60 + values.minute };
  }

  function dateFromKey(key) {
    const [year, month, day] = String(key).split('-').map(Number);
    return new Date(Date.UTC(year, month - 1, day, 12));
  }

  function dateKey(date) {
    return `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, '0')}-${String(date.getUTCDate()).padStart(2, '0')}`;
  }

  function addDays(key, amount) {
    const date = dateFromKey(key);
    date.setUTCDate(date.getUTCDate() + amount);
    return dateKey(date);
  }

  function daysBetween(from, to) {
    return Math.round((dateFromKey(to).getTime() - dateFromKey(from).getTime()) / 86400000);
  }

  function weekday(key) {
    return dateFromKey(key).getUTCDay();
  }

  function valueForWeekday(map, day) {
    return int(map?.[day], int(map?.default, 0));
  }

  function timeMinutes(value) {
    if (!validTime(value)) return 0;
    const [hour, minute] = value.split(':').map(Number);
    return hour * 60 + minute;
  }

  function getDateWindow(rule, timestamp = Date.now()) {
    const now = zonedParts(timestamp);
    const orderWeekday = now.weekday;
    const cutoffPassed = now.minuteOfDay >= timeMinutes(rule.cutoffTime);
    const leadDays = valueForWeekday(rule.leadDays, orderWeekday);
    const maxDaysAhead = valueForWeekday(rule.maxDaysAhead, orderWeekday);
    return {
      now,
      orderWeekday,
      leadDays,
      maxDaysAhead,
      cutoffPassed,
      earliestKey: addDays(now.dateKey, leadDays + (cutoffPassed ? 1 : 0)),
      maximumKey: addDays(now.dateKey, maxDaysAhead),
    };
  }

  function oneOffState(rule, key) {
    const entry = rule.oneOffDates.find((item) => item.date === key);
    return entry ? entry.available : null;
  }

  function isSelectableDate(rule, key, window) {
    if (!validDateKey(key) || key < window.earliestKey || key > window.maximumKey) return false;
    if (rule.availabilityStartDate && key < rule.availabilityStartDate) return false;
    if (rule.availabilityEndDate && key > rule.availabilityEndDate) return false;
    const override = oneOffState(rule, key);
    if (override != null) return override;
    if (rule.disabledDates.includes(key)) return false;
    return rule.availableWeekdays.includes(weekday(key));
  }

  function getAvailableSlots(rule, selectedDateKey, timestamp = Date.now()) {
    if (!rule?.enabled) return [];
    const now = zonedParts(timestamp);
    return rule.slots.map((slot) => {
      const cutoff = timeMinutes(slot.start) - rule.preparationMinutes;
      const available = selectedDateKey > now.dateKey || (selectedDateKey === now.dateKey && now.minuteOfDay < cutoff);
      return { ...slot, available };
    });
  }

  function firstAvailableSlot(slots) {
    return (Array.isArray(slots) ? slots : []).find((slot) => slot.available) || null;
  }

  function findFirstSelectableDate(dateRule, timeRule, timestamp = Date.now()) {
    const window = getDateWindow(dateRule, timestamp);
    let key = window.earliestKey;
    while (key <= window.maximumKey) {
      if (isSelectableDate(dateRule, key, window)) {
        const slots = getAvailableSlots(timeRule, key, timestamp);
        if (!timeRule?.enabled || firstAvailableSlot(slots)) return { key, window, slots };
      }
      key = addDays(key, 1);
    }
    return { key: '', window, slots: [] };
  }

  function formatDate(key) {
    const date = dateFromKey(key);
    return `${MONTH_NAMES[date.getUTCMonth()]} ${date.getUTCDate()}, ${date.getUTCFullYear()}`;
  }

  function formatDay(key) {
    return DAY_NAMES[weekday(key)];
  }

  function formatLongDate(key) {
    const date = dateFromKey(key);
    return `${DAY_NAMES[weekday(key)]}, ${date.getUTCDate()} ${MONTH_NAMES[date.getUTCMonth()]}, ${date.getUTCFullYear()}`;
  }

  function assignmentMatches(assignment, context, sets) {
    if (assignment.scope === 'all') return true;
    if (assignment.scope === 'product') {
      return assignment.productIds.includes(sets.productId)
        || assignment.productHandles.some((value) => normalizeText(value) === sets.productHandle);
    }
    return matchAny(sets.collectionIds, assignment.collectionIds, normalizeId)
      || matchAny(sets.collectionHandles, assignment.collectionHandles)
      || matchAny(sets.collectionTitles, assignment.collectionTitles);
  }

  // Product assignments outrank collection assignments, which outrank all-products assignments.
  function resolvePostcodeRule(config, context) {
    if (!config.postcode.enabled) return null;
    const specificity = { product: 0, collection: 1, all: 2 };
    const sets = contextSets(context);
    const rules = new Map(config.postcode.rules.filter((rule) => rule.enabled).map((rule) => [rule.id, rule]));
    const candidates = config.postcode.assignments.filter((assignment) => assignment.enabled && rules.has(assignment.ruleId))
      .filter((assignment) => assignmentMatches(assignment, context, sets))
      .sort((a, b) => specificity[a.scope] - specificity[b.scope]
        || rules.get(a.ruleId).priority - rules.get(b.ruleId).priority
        || a.priority - b.priority);
    return candidates.length ? rules.get(candidates[0].ruleId) : null;
  }

  function pincodeInRule(rule, pincode) {
    const exact = rule.pincodes.includes(pincode);
    const inRange = rule.ranges.some((range) => pincode >= range.from && pincode <= range.to);
    return exact || inRange;
  }

  function validatePincode(config, rule, value) {
    const pincode = normalizePincode(value);
    if (!rule || pincode.length !== 6) return { valid: false, pincode, complete: pincode.length === 6 };
    const listed = pincodeInRule(rule, pincode);
    const valid = rule.type === 'pan_india' || (rule.type === 'whitelist' ? listed : !listed);
    return {
      valid,
      complete: true,
      pincode,
      message: valid
        ? (rule.availableMessage || config.postcode.availableMessage)
        : (rule.unavailableMessage || config.postcode.unavailableMessage),
    };
  }

  return {
    TIMEZONE, DAY_NAMES, MONTH_NAMES, DEFAULT_CONFIG: clone(DEFAULT_CONFIG),
    normalizeConfig, normalizeText, normalizePincode, matchProductGroup, resolveProfile,
    zonedParts, dateFromKey, addDays, daysBetween, weekday, valueForWeekday, getDateWindow,
    isSelectableDate, getAvailableSlots, firstAvailableSlot, findFirstSelectableDate, formatDate, formatDay, formatLongDate,
    resolvePostcodeRule, validatePincode,
  };
});
